var _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 258,
    viewBox: "0 0 300 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chair4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.188 163.251L191.37 256.779L197.566 256.696L209.384 164.127L203.188 163.251Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.211 163.251L220.029 256.779L213.833 256.696L202.015 164.127L208.211 163.251Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.238 163.251L256.055 256.779L249.859 256.696L238.042 164.127L244.238 163.251Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.295 177.952C158.899 177.952 154.524 173.578 154.524 168.181C154.524 162.785 158.899 158.41 164.295 158.41H203.607C209.329 158.41 214.112 154.056 214.647 148.359L220.947 81.2604C221.482 75.5633 226.265 71.209 231.987 71.209H257.186C263.644 71.209 268.736 76.706 268.242 83.145L261.755 167.713C261.312 173.49 256.494 177.952 250.699 177.952H164.295Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.526 168.099C154.585 168.1 154.645 168.1 154.704 168.1H240.876C246.67 168.1 251.487 163.639 251.932 157.863L258.414 73.5936C258.474 72.8129 258.452 72.046 258.355 71.3011C257.887 71.241 257.41 71.21 256.925 71.21H231.84C226.119 71.21 221.337 75.5626 220.801 81.2584L214.505 148.115C213.969 153.811 209.187 158.163 203.466 158.163H164.27C158.888 158.163 154.524 162.527 154.524 167.909C154.524 167.972 154.525 168.036 154.526 168.099Z",
    fill: "#B2B0B0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Wom3.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.504 226.13C163.504 226.13 168.642 238.468 164.43 241.738C160.212 245.01 152.008 253.099 152.008 253.099L178.588 247.325L172.027 224.689L163.504 226.13Z",
    fill: "url(#paint0_linear_10309_88919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.029 234.256C165.029 234.256 165.682 240.046 163.796 242.022C161.912 243.997 151.706 251.517 150.907 252.944C150.107 254.372 151.537 255.947 151.537 255.947C151.537 255.947 162.56 256.906 167.518 253.889C171.097 251.71 176.435 247.797 176.435 247.797L177.849 251.645L181.856 251.481C181.856 251.481 182.387 246.74 181.436 244.467C180.485 242.193 175.587 230.623 175.587 230.623C175.587 230.623 173.702 232.319 171.699 233.173C169.696 234.027 167.187 236.365 167.187 236.365L165.029 234.256Z",
    fill: "#323740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.97 134.655C199.033 135.054 149.295 146.057 140.259 147.926C131.222 149.796 123.582 159.911 130.473 171.624C138.213 184.772 158.182 222.112 163.03 230.53C165.43 234.696 177.536 232.36 174.693 225.367C169.391 212.331 166.929 179.584 153.414 167.644C153.414 167.644 198.867 175.556 218.5 166.493C232.769 159.905 229.541 133.69 207.97 134.655Z",
    fill: "#42474F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.628 76.9074C145.628 76.9074 145.729 69.6347 143.185 65.834C140.642 62.0332 140.541 57.996 138.616 58.1282C136.691 58.2603 138.597 67.6443 138.597 67.6443C138.597 67.6443 136.154 66.711 134.4 65.5305C132.645 64.35 127.325 58.5303 126.081 59.5616C123.973 61.3187 127.369 71.2306 129.218 73.2123C131.074 75.1945 141.21 81.7129 141.21 81.7129L166.037 107.104L170.698 94.2053L145.628 76.9074Z",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.547 74.5113C196.39 84.155 188.778 101.871 185.64 107.156C181.708 113.775 175.507 116.691 168.246 111.78C166.319 110.477 160.447 105.495 160.447 105.495L167.553 89.854L172.162 93.6586C172.162 93.6586 179.963 73.6562 186.239 62.0689C191.674 52.0441 206.874 59.8507 200.547 74.5113Z",
    fill: "#6F2DBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.08 93.6673C172.08 93.6673 169.985 100.776 169.495 100.364C169.005 99.9526 169.869 91.8096 169.869 91.8096L172.08 93.6673Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.319 90.7191L163.377 110.624L157.065 105.669L165.85 88.0234L169.319 90.7191Z",
    fill: "#392D69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.078 7.218C208.078 7.218 211.198 2.06326 216.15 2.45196C221.101 2.84066 227.111 10.3969 226.799 18.7668C226.497 27.1355 228.34 28.4527 231.893 33.2941C241.442 46.3196 226.696 61.5602 226.696 61.5602L207.095 61.5595L206.337 25.0518L208.078 7.218Z",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.854 10.2352C229.213 19.3693 221.562 29.9621 220.225 32.4494C217.661 50.5501 222.959 51.4812 230.955 55.5286L228.176 60.5043L216.717 58.3412L207.039 11.1465L215.854 10.2352Z",
    fill: "black",
    fillOpacity: 0.199355
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.161 54.3015C222.161 54.3015 215.354 52.933 215.151 43.3815C214.949 33.83 216.071 30.5696 216.071 30.5696L203.233 30.3379C203.233 30.3379 203.093 40.9829 203.091 44.8332C203.086 54.1951 195.881 55.281 195.881 55.281C195.881 55.281 197.379 62.6867 209.011 63.341C218.094 63.8526 222.161 54.3015 222.161 54.3015Z",
    fill: "#F9C7B0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.591 9.92387C216.056 4.41518 206.977 3.07282 205.297 7.32723C205.297 7.32723 204.836 11.119 207.792 12.5996C211.789 14.5942 215.591 9.92387 215.591 9.92387Z",
    fill: "#FB9934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.808 24.116C222.364 22.7085 223.194 31.1047 217.372 32.3305C217.372 32.3305 216.469 44.7004 204.734 47.1946C195.205 49.2202 191.698 35.772 191.036 33.0813C190.329 30.2126 188.3 20.7256 188.3 20.7256L215.102 15.0157L216.808 24.116Z",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.943 29.7994C213.934 29.7414 212.55 24.4998 212.55 24.4998C209.575 24.5398 208.936 24.002 206.027 20.9214C196.883 24.9995 190.512 27.0055 191.163 34.1995C191.163 34.1995 180.526 19.5302 191.906 11.0939C201.917 3.68064 214.623 5.9456 218.541 14.3432C221.312 20.2698 220.628 25.2004 220.628 25.2004C220.628 25.2004 218.684 23.1959 216.423 24.2803C214.163 25.3647 215.952 29.8575 214.943 29.7994Z",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M205.331 38.8857C205.331 38.8857 203.039 41.8469 199.331 40.3185",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M204.07 42.0209C203.285 42.6071 202.454 42.8143 201.622 42.573",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M217.174 28.6504C216.836 27.347 217.016 26.2168 218.312 25.7217",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.564 54.0092C198.407 54.0016 192.917 56.4108 192.285 57.3396C188.167 63.3905 180.606 84.6875 180.216 89.3076C179.778 94.6368 187.449 103.126 187.543 110.841C187.626 118.557 184.261 141.789 185.567 143.959C186.862 146.129 195.372 156.437 197.147 156.479C198.933 156.521 200.266 151.109 202.971 151.227C205.665 151.345 211.283 158.52 213.706 158.469C216.118 158.416 241.117 142.556 239.206 138.037C237.285 133.518 228.367 122.288 229.275 116.13C230.173 109.974 237.347 87.2477 239.937 79.513C242.516 71.7782 244.595 65.6166 239.781 62.2883C234.967 58.9601 219.303 52.8721 219.303 52.8721L205.278 60.7288C205.278 60.7288 199.378 54.0485 198.564 54.0092Z",
    fill: "#6F2DBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.552 60.5078C199.346 74.5163 193.573 88.3194 191.261 101.455L197.986 97.8264L204.189 102.533C203.751 88.8768 206.04 74.5375 207.093 60.5078L203.552 60.5078Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.118 71.2689L228.278 72.4017C230.162 86.4693 227.932 103.54 224.068 106.144C220.123 108.803 204.769 106.194 204.769 108.299C204.769 110.404 225.987 129.699 222.504 138.923C220.589 143.995 221.23 148.505 224.428 152.454L225.357 151.829C232.604 146.906 240.298 140.621 239.206 138.039C237.285 133.52 228.367 122.29 229.275 116.133C230.137 110.222 236.783 89.0416 239.605 80.5133L240.504 77.8094C241.548 74.639 242.418 71.7672 242.628 69.2892L241.98 68.8682C231.616 62.215 226.996 63.0154 228.118 71.2689Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.89 53.8641L219.302 52.8721L204.97 60.3222C204.97 60.3222 207.665 67.1901 212.437 63.7701C216.527 60.8456 214.802 58.272 218.008 56.9445C221.204 55.617 221.89 53.8641 221.89 53.8641Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.971 60.3224C203.932 62.6334 201.82 63.9837 200.728 63.5639C198.926 62.8706 199.7 60.108 198.989 58.7124C198.48 57.7223 198.152 57.5728 197.706 56.6432C197.293 55.7904 197.276 54.7669 197.382 54.4845L198.792 53.8428C198.792 53.8428 200.729 55.6727 201.631 56.6432C202.754 57.8526 204.971 60.3224 204.971 60.3224Z",
    fill: "#392D69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.749 97.4267C220.749 97.4267 212.312 89.9572 209.729 89.0904C207.145 88.2236 192.017 87.1822 192.113 89.141C192.221 91.2394 200.347 91.1187 201.189 92.1511C202.03 93.183 202.222 100.239 205.404 101.031C208.581 101.823 218.103 103.189 218.103 103.189L240.88 116.929L241.853 104.375L220.749 97.4267Z",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.198 65.8011C252.088 78.35 259.678 97.4651 262.591 104.917C265.505 112.37 262.566 123.611 249.755 121.404C247.592 121.031 242.74 119.537 242.74 119.537L239.678 102.277L243.627 103.935C243.627 103.935 230.894 81.3618 227.785 75.3105C222.592 65.2045 235.368 54.7443 243.198 65.8011Z",
    fill: "#6F2DBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.627 103.935C243.627 103.935 250.094 107.094 249.281 105.704C248.467 104.315 241.187 99.5449 241.187 99.5449L243.627 103.935Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.01 103.138L245.125 121.802L236.762 119.143L238.024 100.853L243.01 103.138Z",
    fill: "#392D69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.463 226.551C132.463 226.551 132.618 238.766 122.555 243.334C112.497 247.9 105.331 247.625 106.243 251.156C107.155 254.687 133.334 254.544 135.779 251.783C137.863 249.434 142.394 227.561 143.641 229.234L132.463 226.551Z",
    fill: "url(#paint1_linear_10309_88919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.851 236.181C141.851 236.181 139.736 241.368 139.55 244.512C139.363 247.657 134.548 256.597 134.548 256.597L130.745 257.074L130.397 253.833C130.397 253.833 124.892 256.18 121.438 256.554C117.985 256.93 106.139 255.522 103.784 253.563C101.427 251.606 102.618 248.849 109.417 247.169C116.216 245.489 126.78 240.581 128.79 237.027C130.8 233.473 130.812 233.565 130.812 233.565L130.772 239.487C130.772 239.487 132.512 236.37 134.566 235.954C136.62 235.539 141.851 236.181 141.851 236.181Z",
    fill: "#323740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.993 130.882C234.993 130.882 251.902 156.366 231.686 167.748C214.42 177.469 161.17 166.083 161.17 166.083C161.17 166.083 162.114 173.689 161.17 180.473C158.703 198.19 146.97 227.708 144.488 231.417C141.055 236.546 130.599 232.678 130.402 228.407C130.205 224.137 138.284 169.591 139.513 159.189C140.735 148.787 144.595 147.276 155.866 144.433C158.455 143.78 189.077 136.168 191.883 136.39C215.986 138.296 234.993 130.882 234.993 130.882Z",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    opacity: 0.439941,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.709 164.919C205.228 166.878 158.947 162.84 157.089 164.675C155.314 166.427 155.61 196.908 151.629 214.549C155.551 203.86 159.795 190.339 161.169 180.476C162.113 173.692 161.169 166.086 161.169 166.086L162.977 166.447C172.412 168.28 216.153 176.15 231.685 167.751C240.794 162.825 244.319 155.198 242.258 144.869C239.774 157.053 233.257 163.737 222.709 164.919Z",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.93815,
    cy: 5.38755,
    rx: 2.93815,
    ry: 5.38755,
    transform: "matrix(-0.97437 0.224951 0.224951 0.97437 133.71 154.675)",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 3.91756,
    cy: 5.8773,
    rx: 3.91756,
    ry: 5.8773,
    transform: "matrix(-0.961262 -0.275637 -0.275637 0.961262 151.155 152.584)",
    fill: "white",
    fillOpacity: 0.192499
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Example Task1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M100.56 61.8746C99.728 60.3321 100.727 58.4389 102.47 58.2549L129.946 55.3545C130.921 55.2515 131.865 55.7372 132.349 56.591L150.127 87.9967C150.968 89.4823 150.08 91.3523 148.397 91.6394L121.028 96.3092C119.986 96.4871 118.947 95.9802 118.445 95.0496L100.56 61.8746Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.78 61.7427C100.985 60.2469 101.902 58.4133 103.575 58.1515L130.367 53.9598C131.405 53.7975 132.431 54.3103 132.924 55.2374L150.013 87.3781C150.809 88.8738 149.892 90.7074 148.219 90.9692L121.426 95.1609C120.389 95.3232 119.363 94.8104 118.87 93.8833L101.78 61.7427Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M102.76 60.3486L131.386 55.5147L149.041 88.7185L120.551 93.0103L102.76 60.3486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.013 56.1835C109.723 55.6905 110.029 55.0612 110.595 54.9849L121.692 53.4919C122.331 53.406 122.958 53.7111 123.285 54.2661L125.259 57.6205C125.549 58.1135 125.243 58.7428 124.676 58.8191L113.579 60.3121C112.941 60.398 112.313 60.0929 111.987 59.5379L110.013 56.1835Z",
    fill: "#392D69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.114 65.1941C125.495 64.9915 125.968 65.137 126.171 65.5191C126.36 65.8738 126.249 66.3078 125.927 66.5302L125.849 66.5776L113.109 68.7042C112.728 68.9068 112.255 68.7613 112.051 68.3792C111.863 68.0245 111.974 67.5905 112.295 67.3681L112.373 67.3207L125.114 65.1941Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.792 72.1101C129.173 71.9075 129.646 72.053 129.849 72.4351C130.038 72.7898 129.927 73.2238 129.605 73.4462L129.527 73.4936L116.787 75.6202C116.406 75.8228 115.933 75.6773 115.729 75.2953C115.541 74.9405 115.652 74.5065 115.973 74.2842L116.051 74.2367L128.792 72.1101Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.47 79.0261C132.851 78.8236 133.324 78.969 133.527 79.3511C133.716 79.7058 133.605 80.1398 133.283 80.3622L133.205 80.4096L120.465 82.5362C120.084 82.7388 119.61 82.5933 119.407 82.2113C119.219 81.8565 119.33 81.4225 119.651 81.2002L119.729 81.1527L132.47 79.0261Z",
    fill: "#A7C3FF"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.259 131.041H119.979V257.326H100.259V131.041Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.259 126.078H112.091V257.324H100.259V126.078Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5415 131.041H108.156V168.918H30.2616V257.326H10.5415V131.041Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5415 131.041H22.3735V257.326H10.5415V131.041Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 25_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.653 131.041H274.373V257.326H254.653V131.041Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.935 131.041H262.549V177.927H184.655V257.326H164.935V131.041Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3118 126.078L176.654 126.078V177.833H26.3118V126.078Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.977 131.041H173.809V177.835H161.977V131.041Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.935 131.041H176.767V257.326H164.935V131.041Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.927 133.52C168.927 129.41 172.259 126.078 176.369 126.078L277.786 126.078C281.896 126.078 285.228 129.41 285.228 133.52C285.228 137.63 281.897 140.962 277.786 140.962H176.369C172.259 140.962 168.927 137.63 168.927 133.52Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5923 129.054H164.934V143.938H14.5923V129.054Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 133.52C0 129.41 3.33188 126.078 7.44195 126.078H179.185C183.295 126.078 186.627 129.41 186.627 133.52C186.627 137.63 183.295 140.962 179.185 140.962H7.44196C3.33188 140.962 0 137.63 0 133.52Z",
    fill: "#DBDBDB"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.487 113.064H206.565C207.546 113.064 208.341 113.788 208.341 114.68V116.894C208.341 119.008 206.457 120.723 204.133 120.723H201.487C201.067 120.723 200.726 120.413 200.726 120.03C200.726 119.648 201.067 119.338 201.487 119.338H204.133C205.616 119.338 206.819 118.244 206.819 116.894V114.68C206.819 114.553 206.705 114.449 206.565 114.449H201.487C201.067 114.449 200.726 114.139 200.726 113.757C200.726 113.375 201.067 113.064 201.487 113.064Z",
    fill: "#6C5CD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.627 111.306C183.506 111.306 182.598 112.132 182.598 113.152V117.769C182.598 121.093 185.355 123.831 188.902 124.192L188.903 125.156H197.786L197.786 124.171C201.244 123.736 203.906 121.035 203.906 117.769V113.152C203.906 112.132 202.997 111.306 201.877 111.306H184.627Z",
    fill: "#6C5CD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.283 124.706C204.283 124.443 204.07 124.23 203.807 124.23H183.45C183.188 124.23 182.975 124.443 182.975 124.706C182.975 124.958 183.171 125.166 183.422 125.181L190.935 125.635H196.262L203.836 125.181C204.087 125.166 204.283 124.958 204.283 124.706Z",
    fill: "#6C5CD6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "FacingBack Laptop3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9727 124.334C69.9727 123.599 70.5686 123.003 71.3037 123.003H166.86C167.595 123.003 168.191 123.599 168.191 124.334C168.191 125.069 167.595 125.665 166.86 125.665H71.3037C70.5686 125.665 69.9727 125.069 69.9727 124.334Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.675 124.334C134.675 123.599 135.271 123.003 136.006 123.003H166.862C167.598 123.003 168.194 123.599 168.194 124.334C168.194 125.069 167.598 125.665 166.862 125.665H136.006C135.271 125.665 134.675 125.069 134.675 124.334Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3613 86.8813C65.0781 84.7254 66.7562 82.8125 68.9306 82.8125H128.369C130.176 82.8125 131.703 84.1521 131.938 85.9437L136.286 119.051C136.57 121.207 134.891 123.12 132.717 123.12H73.2787C71.4717 123.12 69.9446 121.78 69.7093 119.989L65.3613 86.8813Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3613 86.8813C65.0781 84.7254 66.7562 82.8125 68.9306 82.8125H126.251C128.059 82.8125 129.586 84.1521 129.821 85.9437L134.169 119.051C134.452 121.207 132.774 123.12 130.6 123.12H73.2787C71.4717 123.12 69.9446 121.78 69.7093 119.989L65.3613 86.8813Z",
    fill: "#392D69"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    cx: 98.6769,
    cy: 103.606,
    rx: 4.17628,
    ry: 4.52567,
    transform: "rotate(-37 98.6769 103.606)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 113",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.52 210.745C277.638 192.361 285.013 173.48 291.764 154.183C276.213 168.856 264.12 186.732 265.842 210.745H269.52Z",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.192 212.664C263.27 181.317 264.085 152.205 280.188 135.581C277.967 169.998 273.812 194.244 268.549 212.664H265.192Z",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 112",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.454 209.398C255.457 187.493 246.417 181.214 238.944 158.729C263.401 171.424 264.934 181.907 269.735 209.398H264.454Z",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.613 209.401L243.473 187.496C251.268 189.72 264.297 193.322 264.297 209.401H259.613Z",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 116",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.707 209.397H280.092C283.513 202.245 288.335 197.322 300 203.29C292.354 191.631 276.665 188.102 274.707 209.397Z",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 117",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.756 209.401H274.233C282.451 197.637 285.984 192.511 294.488 182.465C283.285 186.72 271.786 192.511 269.756 209.401Z",
    fill: "#28C76F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.5 207.699H281.119C281.98 207.699 282.679 208.395 282.679 209.253V213.525C288.398 220.709 291.258 227.894 291.258 235.078C291.258 242.041 288.816 249.005 283.932 255.968C283.64 256.384 283.163 256.632 282.653 256.632H256.966C256.457 256.632 255.979 256.384 255.687 255.968C250.803 249.005 248.361 242.041 248.361 235.078C248.361 228.029 251.114 220.98 256.62 213.931L256.94 213.525V209.253C256.94 208.395 257.639 207.699 258.5 207.699Z",
    fill: "#392D69"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10309_88919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 207,
    width: 44,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.5 207.699H281.119C281.98 207.699 282.679 208.395 282.679 209.253V213.525C288.398 220.709 291.258 227.894 291.258 235.078C291.258 242.041 288.816 249.005 283.932 255.968C283.64 256.384 283.163 256.632 282.653 256.632H256.966C256.457 256.632 255.979 256.384 255.687 255.968C250.803 249.005 248.361 242.041 248.361 235.078C248.361 228.029 251.114 220.98 256.62 213.931L256.94 213.525V209.253C256.94 208.395 257.639 207.699 258.5 207.699Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10309_88919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.901 206.352H263.18C253.471 228.857 272.622 242.184 263.18 264.605H242.901V206.352Z",
    fill: "#DEDAF2"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10309_88919",
    x1: 183.188,
    y1: 217.774,
    x2: 180.855,
    y2: 251.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10309_88919",
    x1: 150.126,
    y1: 219.91,
    x2: 148.597,
    y2: 252.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.3fa42df50c133f8644c3d7557106ac9e.svg";
export { ForwardRef as ReactComponent };